import { AlertCircle, LoaderCircle, UtensilsCrossed } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function PageState({ kind = "empty", title, description, onRetry, retryLabel = "Coba lagi", className }) {
  const Icon = kind === "loading" ? LoaderCircle : kind === "error" ? AlertCircle : UtensilsCrossed;
  return (
    <div className={cn("page-state", className)} role={kind === "error" ? "alert" : "status"} aria-live="polite">
      <div className={`page-state-icon ${kind === "error" ? "text-destructive" : "text-heritage"}`}>
        <Icon className={`h-6 w-6 ${kind === "loading" ? "animate-spin" : ""}`} aria-hidden="true" />
      </div>
      <h2 className="font-display text-2xl font-semibold">{title}</h2>
      {description && <p className="mt-2 max-w-sm text-sm leading-relaxed text-muted-foreground">{description}</p>}
      {onRetry && <Button variant="outline" className="mt-5 rounded-full" onClick={onRetry}>{retryLabel}</Button>}
    </div>
  );
}
